import React from "react";
import { Box, HStack, VStack, Text, Icon } from "@chakra-ui/react";
import { FaUser } from "react-icons/fa";
import Customer from "../Customer";

export default function CustomerCard({ ticket, ticketID, colorScheme, cardPadding }) {
  return (
    <Box
      bg={colorScheme.cardBg}
      borderRadius="xl"
      shadow="lg"
      border="1px solid"
      borderColor={colorScheme.borderColor}
      overflow="hidden"
    >


      <Customer
        customerID={ticket.customer ? (ticket.customer.match(/\/(\d+)\//)?.[1] || null) : null}
        ticket={ticket}
        ticketID={ticketID}
      />

    </Box>
  );
}